import { service } from '@maia/customer';
import { showToast } from '@maia/ui';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import Cookies from 'js-cookie';
import { getCustomerOptions } from '../../../../../features/customer/customer/queryOptions';

import { EditPersonalDataForm } from '../../../../../features/edit-customer/personal-data-form';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/edit/_layout/personal-data',
)({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
});

function RouteComponent() {
  const params = Route.useParams();
  const data = Route.useLoaderData();
  const navigate = useNavigate();

  const { mutateAsync: updateAddress, isPending } = useMutation({
    mutationFn: (body: Parameters<typeof service.updatePersonalData>[number]) =>
      service.updatePersonalData(body),
    onSuccess: (response) => {
      showToast({
        intent: 'success',
        title: 'De adres wijziging is aangevraagd!',
        config: { position: 'top-right' },
      });

      if (response.response?.token) {
        Cookies.set('auth_tokens', JSON.stringify(response.response.token), {
          secure: true,
          sameSite: 'strict',
          expires: new Date(response.response.token.refreshTokenExpiresAt),
        });
      }

      navigate({
        to: '/customers/$guid/edit/success',
        params: { guid: params.guid },
      })

    },
    onError: () => {
      showToast({
        intent: 'error',
        title: 'Er ging iets mis',
        description:
          'We konden de adres wijziging niet aanvragen. Probeer het later opnieuw',
        config: { position: 'top-right' },
      });
    },
  });

  return (
    <div className="area-page-content content-grid max-form-width">
      <EditPersonalDataForm customer={data} onSubmit={updateAddress} isPending={isPending} />
    </div>
  );
}
